export default "__VITE_ASSET__6961c7ac__"